module.exports = __webpack_public_path__ + "img/people1.9ae4be77.png";